<template>
  <div>
    <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn @click="openAddCategoryDialog()" color="primary" dark class="btn-responsive">
        <v-icon class="mr-2">mdi-plus-circle</v-icon>เพิ่มหมวดหมู่
      </v-btn>
    </v-toolbar>
    <v-data-table :headers="headers" :items="categoryList" :items-per-page="5">
      <template v-slot:item.no="{ item }">{{ categoryList.indexOf(item) + 1 }}.</template>
      <template v-slot:item.category_color="{ item }">
        <v-avatar>
          <v-icon :color="item.category_color">mdi-circle</v-icon>
        </v-avatar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn :disabled="item.category_id==1 || item.category_id==5" icon @click="editItem(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          :disabled="item.category_id==1 || item.category_id==5"
          icon
          @click="delItem(item.category_id)"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <!-- Dialog add Item -->
    <v-dialog v-model="dialog" persistent max-width="700px" transition="dialog-transition">
      <v-card>
        <v-card-title primary-title>เพิ่มหมวดหมู่</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row align="center" justify="center">
              <v-col cols="12" class="pb-0">
                <v-text-field
                  name="category"
                  dense
                  label="หมวดหมู่"
                  v-model="category"
                  :rules="rule_field_is_empty"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" align="center">
                <v-color-picker class="elevation-1" hide-inputs v-model="color"></v-color-picker>
              </v-col>
              <v-col cols="5" align="center">
                <v-text-field
                  readonly
                  dense
                  outlined
                  :value="showColor"
                  :rules="rule_field_is_empty"
                ></v-text-field>
                <div style="margin-top:-15px">HEX</div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close">ยกเลิก</v-btn>
          <v-btn color="primary" type="submit" :loading="click" text @click="save()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      click: false,
      rule_field_is_empty: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      // types: ["hex"],
      type: "hex",
      hex: "#FF00FF",
      // hexa: "#FF00FFFF/",
      color: "",
      rgba: { r: 255, g: 0, b: 255, a: 1 },
      hsla: { h: 300, s: 1, l: 0.5, a: 1 },
      hsva: { h: 300, s: 1, v: 1, a: 1 },
      // color: "",
      dialog: false,
      category: "",
      editedIndex: -1,
      headers: [
        {
          text: "ลำดับ",
          value: "no",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "หมวดหมู่",
          value: "category_name",
          sortable: false,
          align: "left",
          width: "30%",
        },
        {
          text: "สีหมวดหมู่",
          value: "category_color",
          sortable: false,
          align: "left",
        },
        {
          text: "จัดการ",
          value: "action",
          sortable: false,
          align: "center",
          width: "20%",
        },
      ],
      categoryList: [],
      activityList: [],
    };
  },
  mounted() {},
  created() {
    this.getCategoryList();
    this.getActivityList();
  },
  computed: {
    // color: {
    //   get() {
    //     return this[this.type];
    //   },
    //   set(v) {
    //     this[this.type] = v;
    //   }
    // },
    showColor() {
      if (typeof this.color === "string") return this.color;

      return JSON.stringify(
        Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2));
          return color;
        }, {}),
        null,
        2
      );
    },
  },
  methods: {
    openAddCategoryDialog() {
      this.color = "#FF0000";
      this.dialog = true;
      setTimeout(() => {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }, 100);
    },
    getCategoryList() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/category")
        .then((response) => {
          let category = [];
          category = response.data;
          this.categoryList = category;
        });
    },
    getActivityList() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/event_cat")
        .then((response) => {
          let get_event = [];
          get_event = response.data;
          this.activityList = get_event;
        });
    },

    // addCategoryItem() {
    //   if (this.$refs.form.validate()) {
    //     // axios.post here!
    //     console.log("ADD ITEM");
    //     this.categoryList.push({
    //       category_id: 0,
    //       category_name: this.category
    //     });
    //     this.dialog = false;
    //   } else {
    //   }
    // },
    editItem(item) {
      // console.log(item);

      this.category = item.category_name;
      this.color = item.category_color;
      this.editedIndex = item.category_id;
      this.dialog = true;
    },
    post() {
      var data = {
        category_name: this.category,
        category_color: this.showColor,
      };
      this.axios
        .post(
          process.env.VUE_APP_API + "/api/v1/category",
          data,
          this.header_token
        )
        .then((res) => {
          if (res.data == "create sucess") {
            this.$swal.fire({
              icon: "success",
              title: "เพิ่มข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.click = false;
            this.getCategoryList();
            this.$emit("getCategory", "add");
            this.$store.state.category_status = true;
            this.close();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "ผิดพลาด กรุณาลองใหม่อีกครั้ง",
              showConfirmButton: true,
            });
            this.getCategoryList();
            this.close();
          }
        });
    },
    put() {
      var id = this.editedIndex;
      var data = {
        category_name: this.category,
        category_color: this.showColor,
      };
      // console.log(data);

      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/category/" + id,
          data,
          this.header_token
        )
        .then((res) => {
          if (res.data == "edit sucess") {
            this.$swal.fire({
              icon: "success",
              title: "แก้ไขข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.click = false;

            this.getCategoryList();
            this.$emit("getCategory", "edit");
            this.$store.state.category_status = true;
            this.close();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "ผิดพลาด กรุณาลองใหม่อีกครั้ง",
              showConfirmButton: true,
            });
            this.getCategoryList();
            this.close();
          }
        });
    },
    delItem(id) {
      this.$store.state.category_status = false;
      this.$swal
        .fire({
          title: "ต้องการลบรายการนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API + "/api/v1/category/" + id,
                this.header_token
              )
              .then((response) => {
                // console.log(response.data);

                if (response.data === "delete success") {
                  this.activityList.forEach((element) => {
                    if (element.category_id == id) {
                      element.file.forEach((file) => {
                        this.axios.delete(
                          process.env.VUE_APP_API +
                            "/api/v1/eventfile/" +
                            file.event_file_id,
                          this.header_token
                        );
                      });
                      this.axios.delete(
                        process.env.VUE_APP_API +
                          "/api/v1/event/" +
                          element.event_id,
                        this.header_token
                      );
                    }
                  });
                  this.axios
                    .delete(
                      process.env.VUE_APP_API + "/api/v1/category/" + id,
                      this.header_token
                    )
                    .then((response) => {
                      // console.log(response.data);
                      this.$swal.fire({
                        icon: "success",
                        title: "ลบข้อมูลสำเร็จ",
                        showConfirmButton: false,
                        timer: 1000,
                      });
                      this.getCategoryList();
                      this.$emit("getCatergory", "delete");
                      this.$store.state.category_status = true;
                      this.close();
                    });
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "ผิดพลาด กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: true,
                  });
                  this.getCategoryList();
                  this.close();
                }
              });
          }
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.state.category_status = false;
        if (this.editedIndex > -1) {
          this.click = true;
          this.put();
        } else {
          this.click = true;
          this.post();
        }
      }
    },
    close() {
      this.click = false;
      this.dialog = false;
      this.editedIndex = -1;
    },
  },
};
</script>
